import { Translation } from 'react-i18next';
import React from 'react';
import { IMPERSONATION_STATUSES, IMPERSONATION_STATUS_KEYS } from 'nallian-shared-ui/lib/impersonation';

export const INFINITE_SCROLL = { loader: 'blocked' };
export const IMPERSONATION_REQUESTS_RESOURCE = 'impersonationRequests';
export const IMPERSONATION_REQUEST_DETAIL_RESOURCE = 'impersonationRequestDetail';
export const REVOKE_IMPERSONATION_RESOURCE = 'revokeImpersonation';

export { IMPERSONATION_STATUSES };

export const IMPERSONATION_STATUS_OPTIONS = [
  {
    key: IMPERSONATION_STATUSES.PENDING,
    value: IMPERSONATION_STATUSES.PENDING,
    text: <Translation ns="shared">{t => t(IMPERSONATION_STATUS_KEYS[IMPERSONATION_STATUSES.PENDING])}</Translation>,
  },
  {
    key: IMPERSONATION_STATUSES.PENDING_CO_APPROVAL,
    value: IMPERSONATION_STATUSES.PENDING_CO_APPROVAL,
    text: <Translation ns="shared">{t => t(IMPERSONATION_STATUS_KEYS[IMPERSONATION_STATUSES.PENDING_CO_APPROVAL])}</Translation>,
  },
  {
    key: IMPERSONATION_STATUSES.ACTIVE,
    value: IMPERSONATION_STATUSES.ACTIVE,
    text: <Translation ns="shared">{t => t(IMPERSONATION_STATUS_KEYS[IMPERSONATION_STATUSES.ACTIVE])}</Translation>,
  },
  {
    key: IMPERSONATION_STATUSES.DENIED,
    value: IMPERSONATION_STATUSES.DENIED,
    text: <Translation ns="shared">{t => t(IMPERSONATION_STATUS_KEYS[IMPERSONATION_STATUSES.DENIED])}</Translation>,
  },
  {
    key: IMPERSONATION_STATUSES.EXPIRED,
    value: IMPERSONATION_STATUSES.EXPIRED,
    text: <Translation ns="shared">{t => t(IMPERSONATION_STATUS_KEYS[IMPERSONATION_STATUSES.EXPIRED])}</Translation>,
  },
  {
    key: IMPERSONATION_STATUSES.REVOKED,
    value: IMPERSONATION_STATUSES.REVOKED,
    text: <Translation ns="shared">{t => t(IMPERSONATION_STATUS_KEYS[IMPERSONATION_STATUSES.REVOKED])}</Translation>,
  },
  {
    key: IMPERSONATION_STATUSES.CONSOLIDATED,
    value: IMPERSONATION_STATUSES.CONSOLIDATED,
    text: <Translation ns="shared">{t => t(IMPERSONATION_STATUS_KEYS[IMPERSONATION_STATUSES.CONSOLIDATED])}</Translation>,
  },
];
